import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import EmergencyIcon from '@material-ui/icons/NotificationImportant';
import DeleteIcon from '@material-ui/icons/RemoveCircleOutline';
import Warning from '@material-ui/icons/Warning';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { BATTERY_IMAGES, TABLE_HEADER_COLOR } from '../../_config/consts';
import * as formatter from '../../_config/formatter';
import { getColorFromThemeName, getStatusColorFromBatteryLevel, isUserWithoutEmail } from '../../_config/utils';
import RemoveEmailIconCustom from '../CustomIcons/RemoveEmailIconCustom.jsx';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 80,
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowWithAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowActionButton: {
    width: 40,
    height: 40,
  },
  rowActionButtonIcon: {
    fontSize: 20,
    color: '#E53935',
  },
  rowBatteryLevel: {
    marginLeft: 10,
    display: 'flex',
    flexDirection: 'row',
    justifycontent: 'center',
    alignItems: 'center',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -15,
    width: 'max-content',
  },
  statusBadge: {
    padding: '4px 8px',
    borderRadius: 4,
    fontSize: 15,
    fontWeight: 'bold',
    display: 'inline-block',
  },
  emergencyBadge: {
    backgroundColor: '#ffebee',
    color: '#d32f2f',
  },
  normalBadge: {
    backgroundColor: '#e8f5e9',
    color: '#388e3c',
  },
});

@connect((state) => ({ 
  viewLoading: state.utils.viewLoading, 
  wearables: state.wearables, 
  themeName: state.settings.items.theme.data.themeName 
}))
class WearableTableView extends React.Component {

  render() {
    const {
      classes,
      viewLoading,
      themeName,
      onDeleteWearable,
      onNewWearable,
      wearables: { selectedWearable, data: { content: wearablesData, pagination: { number: currentPage, size, totalPages, totalElements } }},
      onSelectWearable,
      onRefreshWearables,
      onFetchWearablesOnPage,
    } = this.props;
    const canManageWearables = true //AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.ALL], PERMISSION_ENTITIES.WEARABLES_MANAGEMENT);
    const headerColor = getColorFromThemeName(themeName);
    
    return (
      <div className="list-view details-section" style={{ top: 140, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(wearablesData) ?
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={5}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}><Entity entity="trackingDevices" /></h3>
                        <IconButton onClick={() => onRefreshWearables()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="wearablesTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchWearablesOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchWearablesOnPage(page)}
                        />
                      )}
                    />
                    </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="deviceId" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="user" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="allowedAreas" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="notAllowedAreas" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="status" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="battery" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(wearablesData, (wearable) => {
                    const formattedWearable = formatter.formatInputData(formatter.WEARABLES, wearable);
                    const batteryLevel = formattedWearable.batteryLevel;
                    const textStatusColor = getStatusColorFromBatteryLevel(batteryLevel);
                    const isUserDeleted = wearable && wearable.user && wearable.user.email && !_.includes(wearable.user.email, '@');
                    return (
                      <TableRow
                        key={wearable.id}
                        className={classes.row}
                        hover
                        classes={{
                          selected: classes.rowSelected,
                          hover: classes.rowHovered,
                        }}
                        onClick={event => onSelectWearable(wearable)}
                        selected={selectedWearable && selectedWearable.id === wearable.id}
                      >
                        <TableCell>
                          <div className={classes.rowContainer} style={{ marginTop: 5, marginBottom: 15, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <h5 style={{ fontWeight: 'bold', lineHeight: '1.5', fontSize: 14 }}>{wearable.deviceId}</h5>
                            {wearable.model ? <h5 style={{ fontSize: 12, margin: 0, color: '#757575' }}>{wearable.model}</h5> : null}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowContainer} style={{ display: 'flex', alignItems: 'center' }}>
                            {isUserDeleted ? (
                              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Warning style={{ fontSize: 13, color: 'red', marginTop: 2 }} />
                                <h5 style={{ fontWeight: 'bold', margin: 0, marginLeft: 5, fontSize: 14, color: 'red' }}><Entity entity="userDeleted" /></h5>
                              </div>
                            ) : (
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {wearable && wearable.user ? (
                                  <div>
                                    <h5 style={{ fontWeight: 'bold', fontSize: 14 }}>{`${wearable.user.firstname} ${wearable.user.lastname}`}</h5>
                                    {isUserWithoutEmail(wearable.user) ?  (
                                      <div style={{ display: 'flex', marginTop: 7, marginBottom: 10, flexDirection: 'row', alignItems: 'center' }}>
                                        <RemoveEmailIconCustom style={{ color: '#3f3f3f', width: 15, marginRight: 5 }} />
                                        <h5 style={{ color: '#3f3f3f', margin: 0 }}><Entity entity="noEmailSet" /></h5>
                                      </div>
                                    ) : (<h5 style={{ marginTop: 0, fontSize: 13 }}>{wearable.user.email}</h5>)}
                                  </div>
                                  ) : (
                                    <div>
                                      <h5 style={{ color: '#757575' }}><Entity entity="notAssigned" /></h5>
                                    </div>
                                  )}
                              </div>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowContainer} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            {wearable.allowedAreas && !_.isEmpty(wearable.allowedAreas) ? (
                              _.map(wearable.allowedAreas, (area, index) => (
                                <div key={area.id || index} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                  <div style={{ 
                                    backgroundColor: '#e3f2fd', 
                                    color: '#1976d2', 
                                    padding: '3px 8px', 
                                    borderRadius: 4, 
                                    fontSize: 15,
                                    fontWeight: 'bold'
                                  }}>
                                    {area.name}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <h5 style={{ color: '#757575', fontSize: 13, margin: 0 }}>---</h5>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowContainer} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            {wearable.notAllowedAreas && !_.isEmpty(wearable.notAllowedAreas) ? (
                              _.map(wearable.notAllowedAreas, (area, index) => (
                                <div key={area.id || index} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                  <div style={{ 
                                    backgroundColor: '#ffebee', 
                                    color: '#d32f2f', 
                                    padding: '3px 8px', 
                                    borderRadius: 4, 
                                    fontSize: 15,
                                    fontWeight: 'bold'
                                  }}>
                                    {area.name}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <h5 style={{ color: '#757575', fontSize: 13, margin: 0 }}>---</h5>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowContainer}>
                            {wearable.emergency ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <EmergencyIcon style={{ color: '#d32f2f', fontSize: 20 }} />
                                <span className={`${classes.statusBadge} ${classes.emergencyBadge}`}>
                                  <Entity entity="emergency" />
                                </span>
                              </div>
                            ) : (
                              <span className={`${classes.statusBadge} ${classes.normalBadge}`}>
                                <Entity entity="normal" />
                              </span>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className={classes.rowWithAction}>
                            {batteryLevel !== null && batteryLevel !== undefined && batteryLevel !== -1 ? (
                              <div className={classes.rowBatteryLevel}>
                                <img alt="battery" src={BATTERY_IMAGES[batteryLevel]} style={{ width: 32, height: 12.5 }} />
                                <h5 style={{ margin: 0, marginLeft: 10, color: textStatusColor, fontWeight: 'bold' }}>{batteryLevel}%</h5>
                              </div>
                            ) : (
                              <h5 style={{ fontSize: 14, color: '#757575' }}>---</h5>
                            )}
                          </div>
                        </TableCell>
                        <TableCell>
                          {canManageWearables ? (
                            <Button
                              onClick={(event) => {
                                event.stopPropagation();
                                onDeleteWearable(wearable.id);
                              }}
                              className={classes.button}
                            >
                              <Entity entity="delete" />
                              <DeleteIcon style={{ fontSize: 15, marginLeft: 5 }} />
                            </Button>
                          ) : null}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="wearablesTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchWearablesOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchWearablesOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noWearables"
                    onNewEntity={canManageWearables ? () => onNewWearable() : null}
                    newEntityTitle="addWearable"
                    subtitle="startAddingWearables"
                    iconName="icon-simple-line-icons-plus"
                />) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(WearableTableView);
